import { useDispatch, useSelector } from "react-redux";
import {
  changeMatchState,
  changeUserMode,
} from "../redux/slices/userModeSlice";
import { setArray } from "../redux/slices/finishedTilesArraySlice";
import { setBalance } from "../redux/slices/userSlice";
import {
  resetGameData,
  resetOpenedIndexes,
  setGameData,
} from "../redux/slices/gameDataSlice";
import { changeBetAmount } from "../redux/slices/gameSettingsSlice";
import { lostGame, beforePlay, wonGame } from "../redux/types/userModeTypes";
import cellSelectApi from "../api/openApi";
import { arrayLength } from "../config";
import tileopenMusic from "../audios/tileopen.mp3";
import alienSound from "../audios/alien.mp3";
import cashoutMusic from "../audios/cashout.mp3";

import useSound from "use-sound";
import getSoundEffectVolume from "../utils/getSoundEffectVolume";

const useCellSelect = () => {
  const sounds = useSelector((state) => state.sounds);
  const [playTileOpenMusic] = useSound(tileopenMusic, {
    volume: getSoundEffectVolume(),
    soundEnabled: !sounds.isSoundEffectsMute,
  });
  const [playAlienSound] = useSound(alienSound, {
    volume: getSoundEffectVolume(),
    soundEnabled: !sounds.isSoundEffectsMute,
  });
  const [playCashoutSound] = useSound(cashoutMusic, {
    volume: getSoundEffectVolume(),
    soundEnabled: !sounds.isSoundEffectsMute,
  });
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const gameSettings = useSelector((state) => state.gameSettings);

  const selectCell = async (index) => {
    const res = await cellSelectApi(index, user.uid);
    if (res.result === "won") {
      let myArray = new Array(arrayLength);
      myArray.fill("win");
      res.minesIndexes.forEach((i) => {
        myArray[i] = "lose";
      });
      playCashoutSound();
      dispatch(setGameData(res));
      dispatch(setArray(myArray));
      dispatch(changeUserMode(beforePlay));
      dispatch(changeMatchState(wonGame));
      dispatch(resetOpenedIndexes());
      if (user.balance !== res["currentBalance"]) {
        dispatch(setBalance(res["currentBalance"]));
      }
      return "win";
    } else {
      let newState = "win";
      if (res.cellResult === 0) {
        newState = "lose";
        playAlienSound();
      } else {
        playTileOpenMusic();
      }

      dispatch(setGameData(res));
      if (newState === "lose") {
        let myArray = new Array(arrayLength);
        myArray.fill("win");
        if (res.minesIndexes)
          res.minesIndexes.forEach((i) => {
            myArray[i] = "lose";
          });
        dispatch(setArray(myArray));
        dispatch(changeUserMode(beforePlay));
        dispatch(changeMatchState(lostGame));
        dispatch(resetGameData());

        if (user.balance !== res["currentBalance"]) {
          dispatch(setBalance(res["currentBalance"]));
        }

        if (gameSettings.betAmount > user.balance) {
          dispatch(changeBetAmount(user.balance));
        }
      }
      return newState;
    }
  };
  return selectCell;
};

export default useCellSelect;
